import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import BackButton from 'components/BackButton';
import AlertsBus from 'modules/App/components/AlertsBus';
const MobilePage = ({ backToMessage, to, withAlertBus = true, onClick, children })=>/*#__PURE__*/ _jsxs("div", {
        className: "content__list",
        children: [
            /*#__PURE__*/ _jsx(BackButton, {
                message: backToMessage,
                to: to,
                onClick: onClick
            }),
            withAlertBus && /*#__PURE__*/ _jsx(AlertsBus, {}),
            children
        ]
    });
export default MobilePage;
